module.exports = __webpack_public_path__ + "static/media/openfleet-pin-small.fa6d90ff.svg";